import React from "react"
import axios from 'axios';
import I18n from 'i18n-js';
import '../translations.js';
import axiosDefaults from 'axios/lib/defaults';
import InputMask from 'react-input-mask';
import FileInput from '../shared/FileInput.jsx';
import { ErrorMessage } from '../shared/ErrorMessage.jsx';
import { DynamicMembershipForm } from './dynamic/DynamicMembershipForm.jsx';
import { DynamicOwnerForm } from './dynamic/DynamicOwnerForm.jsx';
import { PersonSelect } from '../shared/PersonSelect.jsx';
import DatePicker from "./datepicker/DatePicker.jsx";
axiosDefaults.headers.common['X-CSRF-Token'] = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

export class NewHorseForm extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      name: this.props.horseData.horse_name || '',
      horseType: 'Horse',
      size: '',
      height: this.props.horseData.horse_height_hands || '',
      sex: this.props.horseData.horse_gender_code || '',
      color: '',
      breed: '',
      dateOfBirth: this.props.horseData.horse_date_of_birth || '',
      age: '',
      sire: this.props.horseData.horse_sire_name || '',
      dam: this.props.horseData.horse_dam_name || '',
      siresDam: this.props.horseData.horse_sire_of_dam_name || '',
      thoroughbred: '',
      greenStatus: '',
      barn: '',
      trainer: '',
      payee: '',
      vaxCert: '',
      vaxCertDate: '',
      blob: '',
      initialForms: [],
      forms: [],
      memberships: [],
      comments: '',
      ownerForms: [],
      owners: [{owner_id: this.props.createUserData.registrant.id}],
      ownerErrorMessage: false,
      createErrorMessage: false,
      showSearch: false
    };
    this.onChange = this.onChange.bind(this);
    this.onCheck = this.onCheck.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.listToSelectOption = this.listToSelectOption.bind(this);
    this.handleAddForm = this.handleAddForm.bind(this);
    this.handleRemoveForm = this.handleRemoveForm.bind(this);
    this.handleDynamicFormNameChange = this.handleDynamicFormNameChange.bind(this);
    this.handleDynamicFormIdChange = this.handleDynamicFormIdChange.bind(this);
    this.handleDynamicOwners = this.handleDynamicOwners.bind(this);
    this.handleAddOwner = this.handleAddOwner.bind(this);
    this.handleRemoveOwner = this.handleRemoveOwner.bind(this);
    this.onFileUpload = this.onFileUpload.bind(this);
    this.onPersonSelect = this.onPersonSelect.bind(this);
    this.handleAddPerson = this.handleAddPerson.bind(this);
    this.handleTrainerChange = this.handleTrainerChange.bind(this);
    this.handlePayeeChange = this.handlePayeeChange.bind(this);
  }

  componentWillMount() {
    this.setState({ ownerForms: [this.ownerForm(this.props.createUserData.registrant.id, false)] })
  }

  componentWillReceiveProps(props) {
    var initialMemberships = [];
    var initialForms = [];
    var oragnization = "";
    if (this.props.usef) {
      initialMemberships = initialMemberships.concat([{name: I18n.t("equine_association.usef"), number: this.props.usef}]);
      initialForms = initialForms.concat([this.diabledForm(1, I18n.t("equine_association.usef"), this.props.usef)]);
      oragnization = I18n.t("equine_association.usef");
    }
    if (this.props.fei) {
      initialMemberships = initialMemberships.concat([{name: "Fédération Équestre Internationale", number: this.props.fei}]);
      initialForms = initialForms.concat([this.diabledForm(2, "Fédération Équestre Internationale", this.props.fei)]);
    }
    if (this.props.ec) {
      initialMemberships = initialMemberships.concat([{name: I18n.t("equine_association.ec"), number: this.props.ec}]);
      initialForms = initialForms.concat([this.diabledForm(3, I18n.t("equine_association.ec"), this.props.ec)]);
      oragnization = I18n.t("equine_association.ec");
    }
    if (this.props.horseData.owner_status === "found") {
      this.setState({ ownerForms: [this.ownerForm(this.props.horseData.owner_id, true)],
                      owners: [{owner_id: this.props.horseData.owner_id}] })
    } else if (this.props.horseData.owner_status === "not found") {
      this.setState({ ownerErrorMessage: "ESM cannot determine the Owner of this horse. ESM has filled you in as the temporary owner so that you can go ahead and create a profile for this horse. " +
        "If you are not the owner of this horse, you must create a profile in ESM for the owner if they are not in ESM, then change the owner in the horse profile." })
    } else {
      this.setState({ ownerErrorMessage: this.props.horseData.horse_owner_name + 
        " is listed as the owner of this horse, but " + this.props.horseData.horse_owner_name +
        " does not have a profile in ESM. Please create a profile for them in your account, using their " + oragnization + 
        " Number: " + this.props.horseData.horse_owner_number +
        ". In the meantime, because the owner field is mandatory, ESM has filled in you as the temporary owner so that " +
        " you can go ahead and create this horse and change the owner to " +
        this.props.horseData.horse_owner_name + " later." })
    }
    if (this.props.horseData.horse_date_of_birth) {
      var date = this.props.horseData.horse_date_of_birth.split('-').reverse().join('/')
      this.handleDateChange(date)
    }
    this.setState({ 
      memberships: initialMemberships,
      initialForms: initialForms
    });
  }

  listToSelectOption(x) {
    return <option key={x}>{x}</option>
  }

  handleDateChange(suppliedDate, formID) {
    const state = this.state;
    var value = suppliedDate;
    var date = new Date(value.split('/').reverse().join('-'));
    if (formID == 'dateOfBirth') {
      state["dateOfBirth"] = value;
      if (value.indexOf('_') < 0 && date.getDate())
      {
        var ageDifMs = Date.now() - date;
        var ageDate = new Date(ageDifMs);
        state["age"] = Math.abs(ageDate.getUTCFullYear() - 1970);
      } else if (value.indexOf('_') < 0) {
        state["age"] = I18n.t("invalid_date");
      }
    }
    if(formID == 'vaxCert'){
      state["vaxCertDate"] = date
      this.setState(state);
    }
    this.setState(state);
  }

  onChange(e) {
    const state = this.state;
    state[e.target.id] = e.target.value;
    this.setState(state);
  }

  onPersonSelect(e) {
    const state = this.state;
    state[e.target.id] = e.target.value;
    this.setState(state);
    if (e.target.value === "new") {
      this.setState({ showSearch: e.target.id })
    } else {
      this.setState({ showSearch: false })
    }
  }

  handleAddPerson(e, target) {
    if (target.includes("owner")) {
      var owners = this.state.owners;
      owners[target.replace("owner", "")].owner_id = e.id;
      this.setState({ owners: owners })
    }
  }

  onCheck(e) {
    const state = this.state;
    state[e.target.id] = e.target.checked;
    this.setState(state);
  }

  handleSubmit(e) {
    e.preventDefault();
    var horse = {
      name: this.state.name,
      type: this.state.horseType,
      size: this.state.size,
      height: this.state.height,
      sex: this.state.sex,
      colour: this.state.color,
      breed: this.state.breed,
      date_of_birth: this.state.dateOfBirth.toString(),
      sire: this.state.sire,
      dam: this.state.dam,
      sire_dam: this.state.siresDam,
      thoroughbred: this.state.thoroughbred,
      green: this.state.greenStatus,
      barn: this.state.barn,
      trainer_id: this.state.trainer,
      payee_id: this.state.payee,
      equine_associations_attributes: this.state.memberships.filter(function(el) {return el.name !== I18n.t("equine_association.select")}),
      comments: this.state.comments,
      vacc_expiry_date: this.state.vaxCertDate,
      horse_owners_attributes: this.state.owners
    }
    var formData = new FormData();
    formData.append('horse', JSON.stringify(horse))
    formData.append('registrant_id', this.props.createUserData.registrant.id)
    formData.append('blob',this.state.blob)
    const config = {
            headers: { 'content-type': 'application/x-www-form-urlencoded' }
        }
    axios.post('/horses', formData, config)
      .then(response => window.location = response.data.url)
      .catch(error => this.setState({ createErrorMessage: error.response.data.join(",") }))
  }

  diabledForm(id,name,number) {
    return  <div key={id} >
              <div className="control-group select optional user_equine_associations_name">
                <label className="select optional control-label">{I18n.t("activerecord.attributes.equine_association.name")}</label>
                <div className="controls">
                   <input className="string optional" type="text" disabled={true} placeholder={name} />
                </div>
              </div>
              <div className="control-group string optional user_equine_associations_number">
                <label className="string optional control-label">{I18n.t("activerecord.attributes.equine_association.number")}</label>
                <div className="controls">
                  <input className="string optional" type="text" disabled={true} placeholder={number} />
                </div>
              </div>
            </div>;
  }


  ownerForm(id, disabled) {
    return <DynamicOwnerForm
              key={0}
              keyId={0}
              ownerOptions={this.props.createUserData.people.map(this.personAsOption)}
              owners={this.state.owners}
              onNameChange={this.handleDynamicOwners}
              addPerson={this.handleAddPerson}
              disabled={disabled}
              ownerId={id} />
  }

  handleAddForm() {
    var memberships = this.state.memberships;
    const organizationList = [I18n.t("equine_association.select"),
      I18n.t("equine_association.ushja"),
      I18n.t("equine_association.thoroughbred_incentive"),
      I18n.t("equine_association.foreign")].map(this.listToSelectOption);
    const key = this.state.forms.length + this.state.initialForms.length
    memberships[key] = {name: "", number: ""}
    this.setState({ memberships: memberships })
    this.setState({
      forms: this.state.forms.concat([
        <DynamicMembershipForm
          key={key}
          keyId={key}
          fieldNames={[I18n.t("horse.issuing_body"), I18n.t("horse.horse_recording")]}
          organizationList={organizationList}
          onNameChange={this.handleDynamicFormNameChange}
          onIdChange={this.handleDynamicFormIdChange} />
      ])
    });
  }

  handleRemoveForm() {
    this.setState({ 
      forms: this.state.forms.slice(0,-1),
      memberships: this.state.memberships.slice(0,-1)
    });
  }

  handleAddOwner() {
    var owners = this.state.owners;
    const key = this.state.owners.length
    owners[key] = {owner_id: ""}
    this.setState(owners)
    this.setState({
      ownerForms: this.state.ownerForms.concat([
        <DynamicOwnerForm
          key={key}
          keyId={key}
          ownerOptions={this.props.createUserData.people.map(this.personAsOption)}
          owners={this.state.owners}
          onNameChange={this.handleDynamicOwners}
          addPerson={this.handleAddPerson}
          diabled={false}
          ownerId={""} />
      ])
    });
  }

  handleRemoveOwner() {
    this.setState({ 
      ownerForms: this.state.ownerForms.slice(0,-1),
      owners: this.state.owners.slice(0,-1)
    });
  }

  handleDynamicOwners(e, key) {
    var owners = this.state.owners;
    owners[key].owner_id = e;
    this.setState({ owners: owners })
  }

  handleDynamicFormNameChange(e, key) {
    var memberships = this.state.memberships;
    memberships[key].name = e;
    this.setState({ memberships: memberships })
  }

  handleDynamicFormIdChange(e, key) {
    var memberships = this.state.memberships;
    memberships[key].number = e;
    this.setState({ memberships: memberships })
  }

  handleTrainerChange(e) {
    this.setState({ trainer: e })
  }

  handlePayeeChange(e) {
    this.setState({ payee: e })
  }

  onFileUpload(e) {
    const state = this.state;
    state[e.target.id] = e.target.value;
    this.setState(state);

    var file = e.target.files[0];
    this.setState({blob: file});
  }

  personAsOption(x) {
    return <option key={x.id} value={x.id}>{x.name}</option>;
  };

  render () {
    return (
      <div>
        <h1>{I18n.t("horse.new_horse")}</h1>
        <div className="row">
          <div className="span12">
            <div className="form-horizontal">
              <form onSubmit={this.handleSubmit}>
                <div className="row">
                  <div className="span6" stylename="min-width: 420px;">
                    <h4>
                      <strong>
                        {I18n.t("horse.horse_information")}
                      </strong>
                    </h4>
                    <div className="control-group string required name">
                      <label className="string required control-label">
                        <abbr title="required">*</abbr> {I18n.t("name")}
                      </label>
                      <div className="controls">
                        <input className="required" type="text" required="required" value={this.state.name} onChange={this.onChange} id="name"/>
                      </div>
                    </div>
                    <div className="control-group string required horseType">
                      <label className="string required control-label">
                        <abbr title="required">*</abbr> {I18n.t("horse.type")}
                      </label>
                      <div className="controls">
                        <select required="required" value={this.state.horseType} onChange={this.onChange} id="horseType">
                          <option key="0">{I18n.t("wizard.horse")}</option>
                          <option key="1">{I18n.t("activerecord.attributes.horse.pony_size",{size: I18n.t("small")})}</option>
                          <option key="2">{I18n.t("activerecord.attributes.horse.pony_size",{size: I18n.t("medium")})}</option>
                          <option key="3">{I18n.t("activerecord.attributes.horse.pony_size",{size: I18n.t("large")})}</option>
                        </select>
                      </div>
                    </div>
                    <div className="control-group string optional size">
                      <label className="string optional control-label">
                        {I18n.t("activerecord.attributes.horse.size")}
                      </label>
                      <div className="controls">
                        <select value={this.state.size} onChange={this.onChange} id="size">
                          <option key="0"></option>
                          <option key="1">{I18n.t("horse.size.s")}</option>
                          <option key="2">{I18n.t("horse.size.m")}</option>
                          <option key="3">{I18n.t("horse.size.l")}</option>
                        </select>
                      </div>
                    </div>
                    <div className="control-group number optional height">
                      <label className="number optional control-label" >{I18n.t("activerecord.attributes.horse.height")}</label>
                      <div className="controls">
                        <input className="number optional" type="number" value={this.state.height} onChange={this.onChange} id="height"/>
                      </div>
                    </div>
                    <div className="control-group string optional size">
                      <label className="string optional control-label">
                        {I18n.t("activerecord.attributes.horse.sex")}
                      </label>
                      <div className="controls">
                        <select value={this.state.sex} onChange={this.onChange} id="sex">
                          <option key="0">{I18n.t("horse.please_select")}</option>
                          <option key="1">{I18n.t("horse.sex.g")}</option>
                          <option key="2">{I18n.t("horse.sex.m")}</option>
                          <option key="3">{I18n.t("horse.sex.s")}</option>
                        </select>
                      </div>
                    </div>
                    <div className="control-group string optional color">
                      <label className="string optional control-label">
                        {I18n.t("activerecord.attributes.horse.color")}
                      </label>
                      <div className="controls">
                        <select value={this.state.color} onChange={this.onChange} id="color">
                          <option key="0"></option>
                          <option value="Bay">Bay</option>
                          <option value="Bay Roan">Bay Roan</option>
                          <option value="Black">Black</option>
                          <option value="Blue Roan">Blue Roan</option>
                          <option value="Brown">Brown</option>
                          <option value="Buckskin">Buckskin</option>
                          <option value="Chestnut">Chestnut</option>
                          <option value="Cremello">Cremello</option>
                          <option value="Dun">Dun</option>
                          <option value="Grullo">Grullo</option>
                          <option value="Palomino">Palomino</option>
                          <option value="Perlino">Perlino</option>
                          <option value="Red Dun">Red Dun</option>
                          <option value="Red Roan">Red Roan</option>
                          <option value="Sorrel">Sorrel</option>
                          <option value="White">White</option>
                        </select>
                      </div>
                    </div>
                    <div className="control-group string optional breed">
                      <label className="string optional control-label">{I18n.t("activerecord.attributes.horse.breed")}</label>
                      <div className="controls">
                        <input className="string optional"  type="text" value={this.state.breed} onChange={this.onChange} id="breed"/>
                      </div>
                    </div>
                    <div className="control-group string required user_date_of_birth">
                      <label className="string required control-label">
                        <abbr title="required">*</abbr> {I18n.t("activerecord.attributes.user.date_of_birth")}
                      </label>
                      <div className="controls">
                        <DatePicker handleDateChange={this.handleDateChange} formID='dateOfBirth' isRequired={true}/>
                      </div>
                    </div>
                    <div className="control-group">
                      <div className="control-label">{I18n.t("activerecord.attributes.horse.age")} {I18n.t("years")}</div>
                      <div className="controls">
                        <p id="age">{this.state.age}</p>
                      </div>
                    </div>
                    <div className="control-group string optional sire">
                      <label className="string optional control-label" >{I18n.t("activerecord.attributes.horse.sire")}</label>
                      <div className="controls">
                        <input className="string optional" type="text" value={this.state.sire} onChange={this.onChange} id="sire"/>
                      </div>
                    </div>
                    <div className="control-group string optional dam">
                      <label className="string optional control-label" >{I18n.t("activerecord.attributes.horse.dam")}</label>
                      <div className="controls">
                        <input className="string optional" type="text" value={this.state.dam} onChange={this.onChange} id="dam"/>
                      </div>
                    </div>
                    <div className="control-group string optional siresDam">
                      <label className="string optional control-label" >{I18n.t("activerecord.attributes.horse.sire_dam")}</label>
                      <div className="controls">
                        <input className="string optional" type="text" value={this.state.siresDam} onChange={this.onChange} id="siresDam"/>
                      </div>
                    </div>
                    <div className="control-group boolean optional thoroughbred">
                      <label className="boolean optional control-label">{I18n.t("entry.thoroughbred")}</label>
                      <div className="controls">
                        <input type="checkbox" checked={this.state.thoroughbred} onChange={this.onCheck} id="thoroughbred"/>
                      </div>
                    </div>
                    <div className="control-group string optional greenStatus">
                      <label className="string optional control-label">
                        {I18n.t("activerecord.attributes.horse.green")}
                      </label>
                      <div className="controls">
                        <select value={this.state.greenStatus} onChange={this.onChange} id="greenStatus">
                          <option key="0"></option>
                          <option key="1">{I18n.t("activerecord.attributes.horse.first")}</option>
                          <option key="2">{I18n.t("activerecord.attributes.horse.second")}</option>
                          <option key="3">{I18n.t("activerecord.attributes.horse.open")}</option>
                        </select>
                      </div>
                    </div>
                    <div className="control-group string optional barn">
                      <label className="string optional control-label">{I18n.t("activerecord.attributes.horse.barn")}</label>
                      <div className="controls">
                        <input className="string optional" type="text" value={this.state.barn} onChange={this.onChange} id="barn"/>
                      </div>
                    </div>
                    <PersonSelect
                      personOptions={this.props.createUserData.people.map(this.personAsOption)} 
                      required={true}
                      label={I18n.t("entry.trainer_with_colon")}
                      person={"trainer"}
                      company={false}
                      handleChange={this.handleTrainerChange}
                    />
                    <PersonSelect
                      personOptions={this.props.createUserData.people.map(this.personAsOption)} 
                      required={false}
                      label={I18n.t("entry.payee_with_colon").slice(0,-1)}
                      person={"payee"}
                      company={true}
                      handleChange={this.handlePayeeChange}
                    />
                    <div className="control-group string optional vaxCert">
                      <label className="string optional control-label" >{I18n.t("horse.upload_new_vax_cert")}</label>
                      <div className="controls">
                        <FileInput className="inputClass" value={this.state.vaxCert} onChange={this.onFileUpload} id="vaxCert"/>
                      </div>
                    </div>
                    <div className="control-group string optional vaxCertDate">
                      <label className="string optional control-label">{I18n.t("horse.vax_expiry")}</label>
                      <div className="controls">
                        <DatePicker handleDateChange={this.handleDateChange} formID='vaxCert'/>
                      </div>
                    </div>
                  </div>
                  <div className="span6">
                    <br/>
                    <br/>
                    <div>
                      <strong>{I18n.t("horse.horse_recording_numbers")}</strong>
                      <br/>
                      <br/>
                      {this.state.initialForms}
                      {this.state.forms}
                      {this.state.memberships.length > this.state.initialForms.length ?
                        <div>
                          <a className="btn btn-danger" onClick={this.handleRemoveForm}>{I18n.t("horse.remove_recording")}</a>
                          <br/>
                          <br/>
                        </div>
                        : undefined}
                      <a className="btn btn-success" onClick={this.handleAddForm}>{I18n.t("horse.add_recording")}</a>
                    </div>
                    <div className="control-group text optional comments">
                      <label className="text optional control-label">{I18n.t("comments")}</label>
                      <div className="controls">
                        <textarea className="text optional" value={this.state.comments} onChange={this.onChange} id="comments"/>
                      </div>
                    </div>
                    <div>
                      <strong><abbr title="required">*</abbr>{I18n.t("wizard.owners")}</strong>
                      <br/>
                      <br/>
                      {this.state.ownerForms}
                      {this.state.owners.length > 1 ?
                        <div>
                          <a className="btn btn-danger" onClick={this.handleRemoveOwner}>{I18n.t("horse.remove_owner")}</a>
                          <br/>
                          <br/>
                        </div>
                        : undefined}
                      <a className="btn btn-success" onClick={this.handleAddOwner}>{I18n.t("horse.add_owner")}</a>
                    </div>
                    {this.state.ownerErrorMessage ? 
                      <ErrorMessage message={this.state.ownerErrorMessage} />
                      :undefined
                    }
                  </div>
                </div>
                {this.state.createErrorMessage ? 
                  <ErrorMessage message={this.state.createErrorMessage} />
                  :undefined
                }
                <a className="btn btn-success" href="/">{I18n.t("home_link")}</a>
                <span> </span>
                <input className="btn btn-primary" type="submit" value={I18n.t("horse.create_horse")}/>
              </form>
            </div>
          </div>
        </div>
        <p>
          <b>{I18n.t("mandatory_field")}</b>
        </p>
      </div>
    );
  }

}

